import React from 'react';

import checkIcon from 'assets/salesNew/check.svg';
import NewLead from 'assets/salesNew/newLead.svg';

import { HEADER_STEPS } from '../salesNewConstants';
import {
  Container,
  HeaderContent,
  HeaderStep,
  HeaderSubTitle,
  HeaderTitle,
  HeaderTitleBlock,
  HeaderTop,
  NewLeadIcon,
  NewLeadImg,
  StepContent,
  StepIcon,
  StepImg,
  StepSubTitle,
  StepTitle,
} from './Header.styles';

const Header = ({ activeStep = 0 }) => {
  return (
    <Container>
      <HeaderTop>
        <NewLeadImg>
          <NewLeadIcon src={NewLead} alt="New Lead" />
        </NewLeadImg>
        <HeaderTitleBlock>
          <HeaderTitle>New Lead</HeaderTitle>
          <HeaderSubTitle>Let&rsquo;s get started</HeaderSubTitle>
        </HeaderTitleBlock>
      </HeaderTop>

      <HeaderContent>
        {HEADER_STEPS.map((step, index) => {
          const isActive = index === activeStep;
          const isCompleted = index < activeStep;

          return (
            <HeaderStep key={index}>
              <StepImg isActive={isActive} isCompleted={isCompleted}>
                <StepIcon
                  src={isCompleted ? checkIcon : step.icon}
                  isActive={isActive || isCompleted}
                  alt={step.title}
                />
              </StepImg>
              <StepContent>
                <StepTitle isActive={isActive || isCompleted}>{step.title}</StepTitle>
                <StepSubTitle>{step.sub}</StepSubTitle>
              </StepContent>
            </HeaderStep>
          );
        })}
      </HeaderContent>
    </Container>
  );
};

export default Header;
